var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18025_34608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.77821 9.16669C2.77821 9.62692 3.15131 10 3.61155 10C4.07178 10 4.44488 9.62692 4.44488 9.16669C4.44488 7.32574 5.93727 5.83335 7.77821 5.83335H15.0737L13.8255 7.22033C13.5176 7.56242 13.5453 8.08933 13.8874 8.39721C14.2295 8.70509 14.7564 8.67736 15.0643 8.33527L17.5643 5.55749C17.8608 5.22805 17.8475 4.72417 17.5341 4.41076L15.0341 1.91076C14.7087 1.58533 14.1811 1.58533 13.8556 1.91076C13.5302 2.2362 13.5302 2.76384 13.8556 3.08928L14.933 4.16669H7.77821C5.01679 4.16669 2.77821 6.40526 2.77821 9.16669Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2227 10.8334C17.2227 10.3731 16.8496 10 16.3893 10C15.9291 10 15.556 10.3731 15.556 10.8334C15.556 12.6743 14.0636 14.1667 12.2227 14.1667H4.92713L6.1754 12.7797C6.48329 12.4376 6.45555 11.9107 6.11346 11.6028C5.77137 11.2949 5.24446 11.3227 4.93658 11.6648L2.43658 14.4425C2.14008 14.772 2.15333 15.2759 2.46674 15.5893L4.96674 18.0893C5.29217 18.4147 5.81981 18.4147 6.14525 18.0893C6.47068 17.7638 6.47068 17.2362 6.14525 16.9108L5.06784 15.8334H12.2227C14.9841 15.8334 17.2227 13.5948 17.2227 10.8334Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18025_34608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRepeat);
export default __webpack_public_path__ + "static/media/iconRepeat.2ba711b6cdfe8a89c4dbb8b0023f1a78.svg";
export { ForwardRef as ReactComponent };